export const deepCopy = <T>(source: T, depth = 0): T => {
	// if (depth === 0) console.log('deepcopy:<-', source);
	const retValue: T = Array.isArray(source)
		? source.map((item) => deepCopy(item, (depth + 1)))
		: source instanceof Date
			? new Date(source.getTime())
			: source && typeof source === 'object'
				? Object.getOwnPropertyNames(source).reduce((o, prop) => {
					Object.defineProperty(o, prop, Object.getOwnPropertyDescriptor(source, prop) || null);
					o[prop] = deepCopy((source as { [key: string]: any})[prop], (depth + 1));
					return o;
				}, Object.create(Object.getPrototypeOf(source)))
				: source as T;
	// if (depth === 0) console.log('deepcopy:->', source);
	return retValue;
};
